<template>
  <div v-if="project.position" class="work w-9/12 h-5/6 md:w-3/12 py-8" 
    :class="{ 
      center : (isMobile == true || project.position == 'center'), 
      left : project.position == 'left' && isMobile == false,
      right : project.position == 'right' && isMobile == false,
    }"
    >
    <router-link :to="`/work/${project.title}`">
    <div @mouseenter="workHover(project)" @mouseleave="workHover('leave')">
      <ImageLoader :small="url + project.frontpage_image.formats.thumbnail.url" :trueSize="url + project.frontpage_image.url"/>
    </div>
     </router-link>
  </div>
</template>

<script>
import { EventBus } from '../EventBus.js';
import ImageLoader from '@/components/ImageLoader.vue'

export default {
  name: "HomepageProject",
  props: ['project'],
  components: {
    ImageLoader
  },
  data() {
    return {
      url: process.env.VUE_APP_VPS_URL,
      isMobile: null
    }
  },
  mounted() {
    let VueThis = this;
    this.isMobile = EventBus.$root.mobile;
    window.addEventListener('resize', function() {
      VueThis.isMobile = EventBus.$root.mobile;
    }); 
  },
  methods: {
      workHover(project) {
        EventBus.$emit('image-hover', project);
      },
      selectProject(project) {
        EventBus.$emit('project-selection', project);
      }
    }
}
</script>

<style scoped>
.work {
  cursor:pointer;
  opacity: 0;
}

.work:hover {
  opacity: 0.6;
}

.center {
  @apply mx-auto opacity-100;
  opacity: 1;
  /* transform: translateY(-50%); */
}

.left {
  @apply mx-auto ml-24 opacity-100;
  opacity: 1;
  /* transform: translateY(-50%); */
}

.right {
 @apply mx-auto mr-24 opacity-100;
 /* transform: translateY(-50%); */
}
</style>